import request from '@/utils/request'
import { deleteEmpty } from '@/api/common'

export function uploadIdMap(options) {
  return request.postJson(
    {
      url: '/api/mapping-gt/save',
      data: { ...deleteEmpty(options) },
    },
    {
      showLoading: false,
      showErrorToast: false,
    }
  )
}
